import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RoundRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateRoundMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.roundsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateRoundMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RoundRequest }) => SSF.api.roundsUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteRoundMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.roundsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
